module.exports = __webpack_public_path__ + "images/category_lp/macbook/store_images/4_09d4412739f80349dcfe0f97cd38e83a.png";